import React, {useEffect, useState} from 'react';

const RenameSpaceModal = ({ isOpen, onClose, onSubmit, spaceName }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [name, setName] = useState(spaceName);
    const [isValidInput, setIsValidInput] = useState(false);

    useEffect(() => {
        setName(spaceName);
        setIsValidInput(false);
        setError('');
    }, [spaceName]);

    if (!isOpen) return null;

    const handleNameChange = (e) => {
        const newName = e.target.value;
        setName(newName);
        if (!newName.trim()) {
            setError('Space name is required');
            setIsValidInput(false);
        } else if (newName.trim() === spaceName) {
            setError('New name must be different from current name');
            setIsValidInput(false);
        } else {
            setError('');
            setIsValidInput(true);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setError('Space name is required');
            return;
        }

        if (name.trim() === spaceName) {
            setError('New name must be different from current name');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            await onSubmit(name);
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg">
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-base font-medium">Rename space</h2>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center justify-center w-8 h-8 text-sm text-gray-400 bg-transparent rounded-lg hover:bg-gray-200 hover:text-gray-900 ms-auto"
                    >
                        <svg
                            className="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                            />
                        </svg>
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-6">
                        <label className="block mb-2 text-sm font-medium text-left text-gray-900">
                            Name
                        </label>
                        <input
                            type="text"
                            value={name}
                            onChange={handleNameChange}
                            className={`w-full px-3 py-2 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-gray-400 text-sm`}
                            required
                        />
                        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
                    </div>
                    <div className="flex justify-end gap-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-1.5 text-sm font-normal text-gray-600 bg-gray-100 rounded hover:bg-gray-200"
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`px-4 py-1.5 text-sm font-normal text-white rounded 
                                ${!isValidInput || isLoading
                                ? 'bg-gray-300 cursor-not-allowed'
                                : 'bg-blue-600 hover:bg-blue-700'}`}
                            disabled={!isValidInput || isLoading}
                        >
                            {isLoading ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RenameSpaceModal;